import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import Login from './pages/Login';
import { verifyToken } from './services/api';

function PrivateRoute({ user, children }) {
  return user ? children : <Navigate to="/login" replace />;
}

function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('ts_token');
    if (!saved) {
      setChecking(false);
      return;
    }
    verifyToken()
      .then((res) => {
        if (res.data.valid) setUser(res.data.username);
        else {
          localStorage.removeItem('ts_token');
          localStorage.removeItem('ts_user');
        }
      })
      .catch(() => {
        localStorage.removeItem('ts_token');
        localStorage.removeItem('ts_user');
      })
      .finally(() => setChecking(false));
  }, []);

  if (checking) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8fafc',
        color: '#64748b',
        fontSize: 16,
      }}>
        Chargement...
      </div>
    );
  }

  return (
    <Router>
      <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
        {user && <Header user={user} onLogout={() => setUser(null)} />}
        <Routes>
          <Route path="/login" element={
            user ? <Navigate to="/" replace /> : <Login onLogin={setUser} />
          } />
          <Route path="/" element={
            <PrivateRoute user={user}><Dashboard /></PrivateRoute>
          } />
          <Route path="/jobs" element={
            <PrivateRoute user={user}><Jobs /></PrivateRoute>
          } />
          <Route path="/jobs/:reference" element={
            <PrivateRoute user={user}><JobDetail /></PrivateRoute>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
